import { GET } from './api'

const configByPortal = {
    essentials: {
        hero: '/student-homes',
        home: '/content-home',
        menu: '/students-content-menu',
        content: '/students-contents/content',
    },
    accelerator: {
        hero: '/accelerator-homes',
        home: '/accelerator-content-home',
        menu: '/accelerator-content-menu',
        content: '/accelerator-contents/content',
    },
}

const getConfig = portal => configByPortal[portal] || configByPortal.essentials

const buildQuery = params => {
    const query = Object.entries(params)
        .filter(([, value]) => value !== undefined && value !== null && value !== '')
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join('&')

    return query ? `?${query}` : ''
}

export const ReadPortalHero = async portal => {
    const config = getConfig(portal)
    return await GET(`${config.hero}?populate=*`, true)
}

export const ReadPortalHomeCourses = async (portal, {
    categoryId,
    subCategoryId,
    page = 1,
    pageSize = 20,
} = {}) => {
    const config = getConfig(portal)
    const query = buildQuery({
        categoryId,
        subCategoryId,
        page,
        pageSize,
    })

    return await GET(`${config.home}${query}`, true)
}

export const ReadPortalMenu = async portal => {
    const config = getConfig(portal)
    return await GET(config.menu, true)
}

export const ReadPortalContent = async (portal, contentType, locale = 'en') => {
    const config = getConfig(portal)
    const query = buildQuery({ locale })
    return await GET(`${config.content}/${contentType}${query}`, true)
}
